/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

/**********************************************************************************************************
 *   SHARED IMPORTS
 **********************************************************************************************************/
import { useGetAuthorisedAccountsQuery, useLogoutMutation, useSelectUserMutation } from 'api/app'
import { useAppSelector } from 'store/hooks'

/**********************************************************************************************************
 *   SHARED COMPONENTS
 **********************************************************************************************************/
import { Button, LFB } from '@nexigendigital/nxui'

/**********************************************************************************************************
 *   STYLE IMPORTS
 **********************************************************************************************************/
import { SelectAccount } from './form.style'

/**********************************************************************************************************
 *   COMPONENT START
 **********************************************************************************************************/
export default function Accounts() {
    const navigate = useNavigate()

    /*   STATE
    *****************************************************/
    const [selectedUser, setSelectedUser] = useState<number | null>(null)
    const {
        appAuthentication: { additionalUsers }
    } = useAppSelector((state) => state.app)

    /*   QUERIES / MUTATIONS
    *****************************************************/
    useGetAuthorisedAccountsQuery(!additionalUsers, { skip: !!additionalUsers })
    const [selectUser, { isLoading: isSelectUserLoading }] = useSelectUserMutation()
    const [logout] = useLogoutMutation()

    /*   FUNCTIONS
    *****************************************************/
    function back() {
        logout()
        navigate('/login', { replace: true })
    }

    /****************************************************
     *  COMPONENT RENDER
     ****************************************************/
    return (
        <>
            <SelectAccount.Container>
                {additionalUsers && additionalUsers.map(({ role: { name }, account: { id, account_holder, company_name } }) => (
                    <LFB
                        key={id}
                        loading={isSelectUserLoading && selectedUser === id}
                        disabled={isSelectUserLoading && selectedUser !== id}
                        label={account_holder}
                        description={company_name ? `${name} - ${company_name}` : name}
                        onClick={() => {
                            setSelectedUser(id)
                            selectUser(id)
                        }}
                    />
                ))}
            </SelectAccount.Container>
            <SelectAccount.Footer>
                <Button type={'button'} color={'secondary'} onClick={back}>Back</Button>
            </SelectAccount.Footer>
        </>
    )
}
